import adminModule from "../admin.module"

adminModule.directive('logView', ($timeout) => ({
  restrict: 'E',
  scope: {
    lines: '=',
    isCollapsed: '='
  },
  template: `
    <div class="clearfix">
      <a 
          ng-click="isCollapsed = !isCollapsed"
          class="pull-right"
          >{{isCollapsed ? 'expand' : 'collapse'}}</a>
    </div>
    <pre ng-show="isCollapsed" ><span class="text-muted">{{lastLine().timestamp}}</span> {{lastLine().message}}</pre>
    
    <pre ng-show="!isCollapsed" class="line-container" style="max-height: 200px; overflow: auto; padding-bottom:10px;"><div ng-repeat="line in lines track by $index"><span class="text-muted">{{line.timestamp}}</span> {{line.message}}</div></pre>
    
  `,
  link(scope, element, attrs) {
    const getContainer = () => element.querySelectorAll('.line-container')[0];
    const getContainerHeight = () => {
      const c = getContainer();
      return c && (c.scrollHeight - c.clientHeight);
    }

    scope.lastLine = () => scope.lines[scope.lines.length - 1]

    const scrollBottom = () => {
      const container = getContainer()
      if (container) {
        container.scrollTop = getContainerHeight(container)
      }
    }
    scope.toggle = () => {
      scope.isCollapsed = !scope.isCollapsed
      if (!scope.isCollapsed) {
        scrollBottom()
      }
    }
    scope.$watch('lines', () => {
      scrollBottom()
    })
  }
}))
